import { Box, Stack, Typography, useTheme } from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

interface TagsProps {
  data: string;
}
export const TagsJobs: React.FC<TagsProps> = ({ data }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        background: theme.palette.background.default,
        height: "21px",
        display: "flex",
        padding: "0.1rem",
        margin: "0px 1px 0 0",
        justifyContent: "start",
        alignContent: "center",
        borderRadius: 50,
        fontSize: 12,
      }}
      className="hiddenText dashedItem"
    >
      <Stack
        direction="row"
        gap={0.5}
        alignItems="center"
        justifyContent="start"
        sx={{ width: "100% !important" }}
      >
        <Typography
          className="hiddenText"
          sx={{
            fontSize: 14,
            fontWeight: 600,
            pl: 1,
            pr: 0.5,
            width: "100% !important",
          }}
        >
          {data}
        </Typography>
      </Stack>
    </Box>
  );
};
